import React, {useEffect, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {obtenerArchivos} from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const ProtocolosServicio = () => {
    const [imagenes, setImagenes] = useState([]);
    const seccionId = 10;

    useEffect(() => {
        obtenerArchivos({seccionId})
            .then((result) => {
                if (result && result.success) {
                    // Filtrar solo imágenes
                    const imagenesFiltradas = result.archivos.filter(archivo => archivo.tipo_mime.startsWith("image/"));
                    setImagenes(imagenesFiltradas);
                } else {
                    console.error(result.mensaje);
                }
            })
            .catch((error) => {
                console.error("Error al obtener las imágenes:", error);
            });
    }, []);

    const responsive = {
        allDevices: {breakpoint: {max: 4000, min: 0}, items: 1},
    };

    return (
        <section className="carousel-protocolo" id="carousels2">
            <Container>
                <div className={"banner-lineamientos"}>
                    <BotonRegresar/>
                    <h1>Protocolos de Servicio</h1>
                </div>
                <Row>
                    <Col>
                        {imagenes.length > 0 ? (
                            <Carousel
                                className="carousel-protocolo-slider"
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                ssr={true}
                                infinite={true}
                                autoPlay={false}
                                autoPlaySpeed={3000}
                                keyBoardControl={true}
                                customTransition="all 0.5s ease"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                {imagenes.map((imagen, index) => (
                                    <div className="item" key={index}>
                                        <img src={imagen.ruta_archivo} alt={imagen.nombre_archivo}
                                             style={{width: "100%", maxHeight: "500px", objectFit: "contain"}}/>
                                    </div>
                                ))}
                            </Carousel>
                        ) : (
                            <p>Cargando imágenes...</p>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
